// extracted by mini-css-extract-plugin
export default {"slotChip":"WorkingHours_slotChip__4+ctq"};